// Route manifest for Inventory Planner. modules.js references this; App.js renders
// the routes. Removing the module = delete this folder and its modules.js entry.
import Landing from "./pages/Landing";
import Forecast from "./pages/Forecast";
import Accuracy from "./pages/Accuracy";
import CostSupply from "./pages/CostSupply";
import Inputs from "./pages/Inputs";
import SettingsIP from "./pages/SettingsIP";

export const IP_ROUTES = [
  { path: "/ip", element: Landing },
  { path: "/ip/forecast", element: Forecast },
  { path: "/ip/accuracy", element: Accuracy },
  { path: "/ip/cost-supply", element: CostSupply },
  { path: "/ip/inputs", element: Inputs },
  { path: "/ip/settings", element: SettingsIP },
];

export const IP_NAV = {
  key: "inventory_planner",
  name: "Inventory Planner",
  accent: "#8b5cf6",
  entry: "/ip",
  nav: [
    { name: "Overview", path: "/ip" },
    { name: "Forecast", path: "/ip/forecast" },
    { name: "Accuracy", path: "/ip/accuracy" },
    { name: "Cost & Supply", path: "/ip/cost-supply" },
    { name: "Inputs", path: "/ip/inputs" },
    { name: "Settings", path: "/ip/settings" },
  ],
  routes: ["/ip", "/ip/forecast", "/ip/accuracy", "/ip/cost-supply", "/ip/inputs", "/ip/settings"],
};
